<div class="modal-header">
	<h2 i18n="@@invoices.reference_id">Invoice Reference Id</h2>
	<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss()">
		<svg version="1.1" x="0px" y="0px" width="14" height="14"  viewBox="0 0 14 14">
			<path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5"/>
		</svg>
	</button>
</div>
<div class="modal-footer">
	<!-- <ng-container  *ngIf="invResponse"> -->
		<input type="text" value="{{ invResponse.url }}" readonly #invoiceLinkInput/>
		<button type="button" class="tu-btn blue" (click)="copyLink(invoiceLinkInput)" i18n="@@invoices.quickpayment.copy_reference_id">Copy Reference Id</button>
	<!-- </ng-container> -->
</div>